import { connect } from 'react-redux';
import { errorsAlertsMessagesSorted } from 'modules/errors-module';
import AlertErrorsView from './alert-errors-view';

export const mapStateToProps = (state) => ({
  alertMessages: errorsAlertsMessagesSorted(state)
});

export default connect(mapStateToProps)(AlertErrorsView);
